// import React, { useState, useRef, useEffect } from "react";
// import styles from "./CustomAutoSearch.module.css";
// import AnimatedButton from "../AnimatedButton/AnimatedButton";
// const CustomAutoSearch = ({
//     value,
//     placeholder,
//     disabled,
//     results = [],
//     onChange,
//     onSelect,
//     fetchResults,
//     defaultStyle = true,
//     dropdownPosition = "relative",
// }) => {
//     const [focused, setFocused] = useState(false);
//     const wrapperRef = useRef(null);
//     useEffect(() => {
//         function handleClickOutside(e) {
//             if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//                 setFocused(false);
//             }
//         }
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);
//     return (
//         <div className={styles.wrapper} ref={wrapperRef}>
//             {/* Input */}
//             <div
//                 className={`${styles.inputBox} ${!defaultStyle ? styles.noDefaultStyle : ""
//                     }`}
//             >
//                 {defaultStyle && (
//                     <span className={styles.searchIcon}>
//                         <img src="/svg/Search-Icon.svg" alt="Search-Icon" />
//                     </span>
//                 )}
//                 <input
//                     type="text"
//                     value={value}
//                     disabled={disabled}
//                     placeholder={placeholder}
//                     onFocus={() => setFocused(true)}
//                     onChange={(e) => {
//                         const text = e.target.value;
//                         onChange(text);

//                         if (text.trim().length > 0) {
//                             fetchResults(text);
//                         } else {
//                             // Clear dropdown
//                             fetchResults([]);
//                         }
//                     }}

//                     className={styles.input}
//                 />
//             </div>

//             {/* Dropdown */}
//             {focused && results.length > 0 && (
//                 // <div className={styles.dropdown}>
//                                 <div
//                     className={`${styles.dropdown} ${dropdownPosition === "absolute" ? styles.absolute : styles.relative
//                         }`}
//                 >
//                     {results.map((item, i) => (
//                         <div
//                             key={i}
//                             className={styles.option}
//                             onClick={() => {
//                                 onSelect(item);
//                                 setFocused(false);
//                             }}
//                         >
//                             <div className={styles.icon}><img src="/svg/location-new.svg" alt="location-new.svg" /></div>

//                             <div>
//                                 <div className={styles.title}>
//                                     {item.structured_formatting?.main_text}
//                                 </div>

//                                 <div className={styles.subtitle}>
//                                     {item.structured_formatting?.secondary_text}
//                                 </div>



//                             </div>
//                         </div>
//                     ))}

//                     <div className={styles.powered}>
//                         Powered by <span className={styles.brand}><img src="/svg/powered-rexpt-logo.svg" alt="powered-rexpt-logo" /></span>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default CustomAutoSearch;

// // import React, { useState, useRef, useEffect } from "react";
// // import styles from "./CustomAutoSearch.module.css";

// // const CustomAutoSearch = ({
// //     value,
// //     placeholder,
// //     disabled,
// //     results = [],
// //     onChange,
// //     onSelect,
// //     fetchResults,
// //     defaultStyle = true,
// //     dropdownPosition = "relative",
// // }) => {
// //     const [focused, setFocused] = useState(false);
// //     const wrapperRef = useRef(null);

// //     // Outside click se dropdown band karo
// //     useEffect(() => {
// //         function handleClickOutside(e) {
// //             if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
// //                 setFocused(false);
// //             }
// //         }
// //         document.addEventListener("mousedown", handleClickOutside);
// //         return () => document.removeEventListener("mousedown", handleClickOutside);
// //     }, []);

// //     // Dropdown show hoga ya nahi
// //     // showDropdown prop agar parent de raha hai toh use karo, warna local focused state
// //     const isOpen = showDropdown !== undefined ? showDropdown : (focused && results.length > 0);

// //     return (
// //         <div className={styles.wrapper} ref={wrapperRef}>

// //             {/* Input */}
// //             <div className={`${styles.inputBox} ${!defaultStyle ? styles.noDefaultStyle : ""}`}>
// //                 {defaultStyle && (
// //                     <span className={styles.searchIcon}>
// //                         <img src="/svg/Search-Icon.svg" alt="Search-Icon" />
// //                     </span>
// //                 )}
// //                 <input
// //                     type="text"
// //                     value={value}
// //                     disabled={disabled}
// //                     placeholder={placeholder}
// //                     className={styles.input}
// //                     onFocus={() => {
// //                         setFocused(true);
// //                         onFocus?.(); // parent ka onFocus bhi call karo
// //                     }}
// //                     onKeyDown={onKeyDown} // ← StepTwo ka keyboard handler
// //                     onChange={(e) => {
// //                         const text = e.target.value;
// //                         onChange(text);
// //                         if (text.trim().length > 0) {
// //                             fetchResults(text);
// //                         } else {
// //                             fetchResults([]);
// //                         }
// //                     }}
// //                 />
// //             </div>

// //             {/* Dropdown */}
// //             {focused && results.length > 0 && (
// //                 <div
// //                     className={`${styles.dropdown} ${dropdownPosition === "absolute" ? styles.absolute : styles.relative
// //                         }`}
// //                 >
// //                     {results.map((item, i) => (
// //                         <div
// //                             key={i}
// //                             // ← highlighted class lagao keyboard nav ke liye
// //                             className={`${styles.option} ${highlightedIndex === i ? styles.highlighted : ""}`}
// //                             onMouseDown={() => {
// //                                 // onMouseDown use karo onClick ki jagah
// //                                 // taaki focus blur se pehle select ho jaye
// //                                 onSelect(item);
// //                                 setFocused(false);
// //                             }}
// //                             onMouseEnter={() => onMouseEnter?.(i)} // ← mouse hover pe index update
// //                         >
// //                             <div className={styles.icon}>
// //                                 <img src="/svg/location-new.svg" alt="location-new.svg" />
// //                             </div>
// //                             <div>
// //                                 <div className={styles.title}>
// //                                     {item.structured_formatting?.main_text}
// //                                 </div>
// //                                 <div className={styles.subtitle}>
// //                                     {item.structured_formatting?.secondary_text}
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     ))}

// //                     <div className={styles.powered}>
// //                         Powered by{" "}
// //                         <span className={styles.brand}>
// //                             <img src="/svg/powered-rexpt-logo.svg" alt="powered-rexpt-logo" />
// //                         </span>
// //                     </div>
// //                 </div>
// //             )}
// //         </div>
// //     );
// // };

// // export default CustomAutoSearch;

import React, { useState, useRef, useEffect } from "react";
import styles from "./CustomAutoSearch.module.css";
import AnimatedButton from "../AnimatedButton/AnimatedButton";

const CustomAutoSearch = ({
    value,
    placeholder,
    disabled,
    results = [],
    onChange,
    onSelect,
    fetchResults,
    defaultStyle = true,
    dropdownPosition = "relative",
    backgroundColor,
    padding,
    // ── NEW: keyboard nav props (StepTwo se aa rahe hain) ──
    showDropdown,
    highlightedIndex = -1,
    onKeyDown,
    onMouseEnter,
    dropdownRef,
    onFocus: onFocusProp,
}) => {
    const [focused, setFocused] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(e) {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setFocused(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Parent showDropdown hai toh woh use karo, warna local focused
    const isOpen = showDropdown !== undefined ? showDropdown : (focused && results.length > 0);

    return (
        <div className={styles.wrapper} ref={wrapperRef} >
            {/* Input */}
            <div
                className={`${styles.inputBox} ${!defaultStyle ? styles.noDefaultStyle : ""
                    }`}
                style={{
                    backgroundColor: backgroundColor || undefined,
                    padding: padding || undefined,
                }}
            >
                {defaultStyle && (
                    <span className={styles.searchIcon}>
                        <img src="/svg/Search-Icon.svg" alt="Search-Icon" />
                    </span>
                )}
                <input
                    type="text"
                    value={value}
                    disabled={disabled}
                    placeholder={placeholder}
                    onFocus={() => {
                        setFocused(true);
                        onFocusProp?.(); // ← parent ka onFocus bhi call karo

                    }}
                    onKeyDown={onKeyDown} // ← StepTwo ka keyboard handler


                    onChange={(e) => {
                        const text = e.target.value;
                        onChange(text);

                        if (text.trim().length > 0) {
                            fetchResults(text);
                        } else {
                            // Clear dropdown
                            fetchResults([]);
                        }
                    }}

                    className={styles.input}

                />
            </div>

            {/* Dropdown */}
            {isOpen && results.length > 0 && (
                <div
                    ref={dropdownRef} // ← scroll ke liye ref
                    className={`${styles.dropdown} ${dropdownPosition === "absolute" ? styles.absolute : styles.relative
                        }`}
                >
                    {results.map((item, i) => (
                        <div
                            key={i}
                            className={`${styles.option} ${highlightedIndex === i ? styles.highlighted : ""}`} // ← highlighted class
                            onMouseDown={(e) => e.preventDefault()} // ← blur rokne ke liye
                            onClick={() => {
                                onSelect(item);
                                setFocused(false);
                            }}
                            onMouseEnter={() => onMouseEnter?.(i)} // ← mouse hover pe index update
                        >
                            <div className={styles.icon}><img src="/svg/location-new.svg" alt="location-new.svg" /></div>

                            <div>
                                <div className={styles.title}>
                                    {item.structured_formatting?.main_text}
                                </div>

                                <div className={styles.subtitle}>
                                    {item.structured_formatting?.secondary_text}
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className={styles.powered}>
                        Powered by <span className={styles.brand}><img src="/svg/powered-rexpt-logo.svg" alt="powered-rexpt-logo" /></span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomAutoSearch;